import Image, { StaticImageData } from 'next/image';
import { Box, Typography } from '@mui/material';

import activitiesImg from '@/../public/greaterCare/ticker/activities.jpg';
import adultCareImg from '@/../public/greaterCare/ticker/adult-care.jpg';
import catWhisperersImg from '@/../public/greaterCare/ticker/cat-whisperers.jpg';
import cleanersImg from '@/../public/greaterCare/ticker/cleaners.jpg';
import companionsImg from '@/../public/greaterCare/ticker/companions.jpg';
import daycaresImg from '@/../public/greaterCare/ticker/daycares.jpg';
import dementiaCareImg from '@/../public/greaterCare/ticker/dementia-care.jpg';
import infantCareImg from '@/../public/greaterCare/ticker/infant-care.jpg';
import nanniesImg from '@/../public/greaterCare/ticker/nannies.jpg';
import toddlerWrangersImg from '@/../public/greaterCare/ticker/toddler-wranglers.jpg';
import tutorsImg from '@/../public/greaterCare/ticker/tutors.jpg';
import walkersImg from '@/../public/greaterCare/ticker/walkers.jpg';

import TickerRowAnimation from './TickerRowAnimation';

type TickerImage = {
  src: StaticImageData;
  text: string;
  textColor: string;
};
export const TICKER_IMAGES: TickerImage[] = [
  { src: nanniesImg, text: 'nannies', textColor: '#F193C5' },
  { src: walkersImg, text: 'dog walkers', textColor: '#025747' },
  { src: daycaresImg, text: 'daycares', textColor: '#FF9437' },
  { src: activitiesImg, text: 'activities & camps', textColor: '#727272' },
  { src: infantCareImg, text: 'infant care', textColor: '#F193C5' },
  { src: cleanersImg, text: 'last minute cleaners', textColor: '#025747' },
  { src: companionsImg, text: 'senior companions', textColor: '#F193C5' },
  { src: tutorsImg, text: 'math tutors', textColor: '#025747' },
  { src: toddlerWrangersImg, text: 'toddler wranglers', textColor: '#FF9437' },
  { src: catWhisperersImg, text: 'cat whisperers', textColor: '#727272' },
  { src: dementiaCareImg, text: 'dementia care', textColor: '#F193C5' },
  { src: adultCareImg, text: 'adult care', textColor: '#025747' },
];

const createTickerImages = (images: TickerImage[], imageGroup: number) => {
  return images.map((image) => {
    return (
      <Box
        key={`${image.text}-${imageGroup}`}
        display="flex"
        flexDirection="row"
        alignItems="center">
        <Box
          sx={{
            flex: '0 0 auto',
            width: { xs: '108px', sm: '128px' },
            height: { xs: '64px', sm: '80px' },
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '16px',
          }}>
          <Image src={image.src} layout="fill" loading="lazy" />
        </Box>
        <Typography
          sx={(theme) => ({
            typography: {
              xs: 'accentDisplay2',
              sm: 'accentDisplay1',
            },
            whiteSpace: 'nowrap',
            margin: { xs: theme.spacing(0, 4, 0, 3), sm: theme.spacing(0, 4) },
            color: image.textColor,
          })}>
          {image.text}
        </Typography>
      </Box>
    );
  });
};

const Ticker = () => {
  const imagesRowTop = [
    ...createTickerImages(TICKER_IMAGES.slice(0, 6), 1),
    ...createTickerImages(TICKER_IMAGES.slice(0, 6), 2),
  ];
  const imagesRowBottom = [
    ...createTickerImages(TICKER_IMAGES.slice(6, 12), 1),
    ...createTickerImages(TICKER_IMAGES.slice(6, 12), 2),
  ];

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        margin: { xs: theme.spacing(6, 'auto'), md: theme.spacing(10, 'auto') },
        overflow: 'hidden',
        alignItems: 'center',
      })}>
      <TickerRowAnimation animateLeftToRight>{imagesRowTop}</TickerRowAnimation>
      <TickerRowAnimation
        animateRightToLeft
        sx={(theme) => ({ marginTop: { xs: theme.spacing(8), md: theme.spacing(10) } })}>
        {imagesRowBottom}
      </TickerRowAnimation>
    </Box>
  );
};

export default Ticker;
